export enum PeriodType {
  _1D = '1D',
  _1W = '1W',
  _1M = '1M',
  _3M = '3M',
  _1A = '1A',
  ALL = '5Y',
}

export interface Period {
  value: PeriodType;
  displayVal: string;
  displayText: string;
  dayjsTimestampFormat: string;
  tooltipOffset: number;
}

export interface Point {
  x: number;
  y: number;
}

export interface GraphDataResponse {
  [key: string]: any;
  points: Point[];
  prevClosePrice?: number;
}
